import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	popup: {
		maxWidth: 520,
	},
	targetTrigger: {
		width: '100%',
	},
});
